export default __webpack_public_path__ + "static/media/Call 2.e0beb6ea.svg";